import _omit from 'lodash/omit';
import type { FC } from 'react';
import React, { useMemo } from 'react';

import { Dialog, Menu, Sheet } from '@sravni/react-design-system';
import { useIsMobile, useStyles } from '@sravni/react-utils';

import { CUSTOMER_TYPE_TO_LABEL, CUSTOMER_TYPES } from '../../../../../constants/filters';
import { useFilters } from '../../../../../store/hooks/filters';
import { useServices } from '../../../../../store/hooks/services';
import type { TService } from '../../../../../types/services';

import styles from './service-dialog.module.scss';

type ServiceDialogProps = {
  isVisible: boolean;
  onClose: () => void;
  onChangeService: (service: TService) => () => void;
};

const title = 'Все услуги';

export const ServiceDialog: FC<ServiceDialogProps> = ({ isVisible, onClose, onChangeService }) => {
  const allServices = useServices();
  const isMobile = useIsMobile();
  const cx = useStyles(styles);
  const { service: currentService, customerType: currentCustomerType } = useFilters();

  const servicesToShow = useMemo(() => {
    if (Object.keys(allServices).length === 1) {
      return allServices;
    }
    return _omit(allServices, CUSTOMER_TYPES.All);
  }, [allServices]);

  const customerTypesCount = Object.keys(servicesToShow).length;

  const ComponentToRender = isMobile ? Sheet : Dialog;

  return (
    <ComponentToRender visible={isVisible} onClose={onClose} fullscreen={isMobile}>
      <ComponentToRender.Header title={title} />
      <ComponentToRender.Content>
        <Menu className={cx('menu')}>
          {Object.entries(servicesToShow).map(([customerType, services]) => {
            const menuItems = services.map((service) => (
              <Menu.Item
                onClick={onChangeService(service)}
                key={[service.customerType, service.key].join('-')}
                active={service.key === currentService?.key && customerType === currentCustomerType}
              >
                {service.label}
              </Menu.Item>
            ));

            if (customerTypesCount === 1) return menuItems;

            return (
              <>
                <Menu.Item key={customerType} className={cx('itemHeader')} disabled>
                  {CUSTOMER_TYPE_TO_LABEL[customerType]}
                </Menu.Item>
                {menuItems}
              </>
            );
          })}
        </Menu>
      </ComponentToRender.Content>
    </ComponentToRender>
  );
};
